module.exports = __webpack_public_path__ + "img/zt_pic0.8dd48edf.jpg";